import React from "react";

function WhyConsider() {
  return (
    <div>
      Are keen on further reinvesting and growing your retirement fund
      <br />
      Need to choose your income (subject to statutory limits)
      <br />
      Need flexibility in frequency of receiving your income
      <br />
      Intend to purchase an annuity at a later date
      <br />
      Have other sources of income and do not need a guaranteed income from your
      retirement savings
      <br />
      Wish to leave an inheritance to your beneficiaries
      <br />
    </div>
  );
}

export default WhyConsider;
